/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

export type InquiryDetailResponseDtoApartmentSubtypesItem = typeof InquiryDetailResponseDtoApartmentSubtypesItem[keyof typeof InquiryDetailResponseDtoApartmentSubtypesItem];


export const InquiryDetailResponseDtoApartmentSubtypesItem = {
  STANDARD: 'STANDARD',
  LOFT: 'LOFT',
  MAISONETTE: 'MAISONETTE',
  PENTHOUSE: 'PENTHOUSE',
} as const;
